// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-pool-component{width:1000px}.create-pool-component .left{width:587px}.create-pool-component .fee{background:rgba(60,60,67,.36);border:1px solid hsla(240,6%,50%,.36);border-radius:4px;cursor:pointer;height:156px;padding:16px 24px;width:185px}.create-pool-component .fee.active{background:#161617;border:1px solid #67c23a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
